import type React from 'react';

export const eventPropagationTrap = <E extends Element>(
  event: React.MouseEvent<E> | React.FocusEvent<HTMLInputElement>,
) => {
  event.stopPropagation();
};
